import { Formik } from 'formik'
import React from 'react'
import { Input, Dropdown, Checkboxes } from 'src/components/Forms'
import { Body, Footer } from 'src/components/theme/Models/Modal'
import { faSave, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { lookupOptionsDocument, useLookupConfig, useMutateCreateLookupOption } from 'src/queries'
import { MutateCreateLookupOptionMutation } from 'src/gql/graphql'
import { useInvalidateQueryByDocument } from 'src/hooks/useGraphQL'

const fieldComponents: Record<string, React.FC<any>> = {
  Input,
  Dropdown,
  Checkboxes
}

interface FormProps {
  lookupId: string
  toggle: (id?: string) => void
}

const Form: React.FC<FormProps> = (props) => {
  const { toggle, lookupId } = props
  const config = useLookupConfig(lookupId ?? '')
  const create = useMutateCreateLookupOption()
  const invalidateOptions = useInvalidateQueryByDocument(lookupOptionsDocument)
  const handleSubmit = (data: MutateCreateLookupOptionMutation): void => {
    const id = data.lookups?.create?._id
    if (typeof id === 'string') {
      void invalidateOptions({ key: lookupId })
      toggle(undefined)
    }
  }
  return (
    <Formik
      initialValues={{}}
      onSubmit={async (values) => {
        create.mutate({
          key: lookupId,
          record: values
        }, {
          onSuccess: handleSubmit
        })
      }}
    >
      {({ handleSubmit, isValid }) => (
        <>
          <Body error={{ show: false, error: 'There was an issue saving the option.', details: '' }}>
            {config?.fields?.map((field) => {
              if (field === null || field === undefined) {
                console.log('Field is null or undefined:', field)
                return null
              }
              const component = field?.component ?? {}
              if (component.type === null || component.type === undefined) {
                console.log('Field component type is null or undefined:', field)
                return null
              }
              const FieldComponent = fieldComponents[component.type] ?? undefined
              if (FieldComponent === undefined) {
                console.log('Could not find a matching field component:', field)
                return null
              }
              return (
                <FieldComponent
                  key={field.key}
                  name={field.key}
                  label={field.title}
                  validate={(value: any) => {
                    if (component.props.required === true) {
                      if (value === undefined || value === null || value === '') {
                        return `${field.title ?? 'This'} is required.`
                      }
                    }
                  }}
                  {...component.props}
                />
              )
            })}
          </Body>
          <Footer
            toggle={() => toggle(undefined)}
            onAction={handleSubmit}
            action={{
              text: 'Create',
              icon: create.isLoading ? faSpinner : faSave,
              color: 'primary',
              disabled: !isValid || create.isLoading
            }}
          />
        </>
      )}
    </Formik>
  )
}

export default Form
